import validateCpf from './validateCpf';

const validateRow = row => {
  const reasons = [];
  if (!row?.name) reasons.push('missing_name');
  if (!row?.cpf) reasons.push('missing_cpf');
  else if (!validateCpf(row.cpf)) reasons.push('invalid_cpf');
  if (!row?.email && !row?.phone) reasons.push('missing_email_or_phone');
  return { valid: reasons.length === 0, reasons };
};

export default validateRow;
